import { useTranslation } from '@frontend/i18n';
import { IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Accordion, useTooltip } from '@frontend/design-system';
import { FilterCount } from '../popover-filter-panel-content/filter-count';

export const CustomAccordionHeader = ({
  title,
  icon,
  filterCount,
  disabled,
}: {
  title: string;
  icon: IconName;
  filterCount?: number;
  disabled?: boolean;
}) => {
  const { t } = useTranslation('scheduleCalendarFilters');
  const { tooltipProps, triggerProps, Tooltip } = useTooltip({ placement: 'bottom' });

  return (
    <>
      <Accordion.Header
        disabled={disabled}
        {...triggerProps}
        css={{
          '.header-container': {
            padding: theme.spacing(1.25, 2),
            justifyContent: 'space-between',
            alignItems: 'center',
          },
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        <Accordion.Header.Icon title={title} icon={icon} css={{ fontWeight: theme.font.weight.bold }} />
        <FilterCount count={filterCount} size='small' />
      </Accordion.Header>
      {disabled && (
        <Tooltip {...tooltipProps}>
          {title} {t('coming soon')}
        </Tooltip>
      )}
    </>
  );
};
